// Shared Monthly/Yearly segmented control used across the public pricing page,
// the authenticated Plans & Storage page and Organizations billing. Purely
// presentational: the parent owns the interval state and passes a REAL savingsPct
// (computed from configured monthly/annual prices) — never a hardcoded number.
export default function BillingToggle({ value = "monthly", onChange, savingsPct, dark = false, idPrefix = "billing-toggle" }) {
  const base = dark ? "border-white/15 bg-white/5" : "border-slate-200 bg-white";
  const activeCls = dark ? "bg-primary text-[#2a2d31]" : "bg-primary text-white";
  const idleCls = dark ? "text-white/60 hover:text-white" : "text-slate-500 hover:text-slate-800";

  const Btn = ({ v, label }) => {
    const on = value === v;
    return (
      <button
        type="button"
        role="radio"
        aria-checked={on}
        onClick={() => onChange?.(v)}
        data-testid={`${idPrefix}-${v}`}
        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary/70 ${on ? activeCls : idleCls}`}
      >
        {label}
      </button>
    );
  };

  return (
    <div role="radiogroup" aria-label="Billing interval" className={`inline-flex items-center gap-1 rounded-full border p-1 ${base}`}>
      <Btn v="monthly" label="Monthly" />
      <Btn v="yearly" label="Yearly" />
      {savingsPct ? (
        <span data-testid={`${idPrefix}-savings`} className={`ml-1 mr-1.5 inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${dark ? "bg-primary/20 text-primary" : "bg-emerald-100 text-emerald-700"}`}>
          Save up to {savingsPct}%
        </span>
      ) : null}
    </div>
  );
}
